const o = {
  chevronPosition: "right",
  showDescription: !1,
  open: !1,
  disabled: !1,
  withBorder: !1
};
export { o as accordionDefaultProps };